import { render, staticRenderFns } from "./detail-layer.vue?vue&type=template&id=0bbe2248&scoped=true"
import script from "./detail-layer.vue?vue&type=script&lang=js"
export * from "./detail-layer.vue?vue&type=script&lang=js"
import style0 from "./detail-layer.vue?vue&type=style&index=0&id=0bbe2248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe2248",
  null
  
)

export default component.exports